const state = {
  theme: {
    colorMenu: 'colorMenu',
    colorMain: 'colorMain',
    colorSecond: 'colorSecond'
  }
}

const actions = {
  setTheme ({ commit }, payload) {
    commit('SET_THEME', payload)
  }
}

const mutations = {
  SET_THEME (state, payload) {
    state.colorMenu = payload.colorMenu
    state.colorMain = payload.colorMain
    state.colorSecond = payload.colorSecond
  }
}

const getters = {
  theme: (state) => state.theme
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
